var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.27214 3.46367C1.27214 2.57513 1.99244 1.85482 2.88099 1.85482C3.76953 1.85482 4.48984 2.57513 4.48984 3.46367C4.48984 4.35221 3.76953 5.07252 2.88099 5.07252C1.99244 5.07252 1.27214 4.35221 1.27214 3.46367ZM2.88099 2.36288C2.27304 2.36288 1.7802 2.85572 1.7802 3.46367C1.7802 4.07162 2.27304 4.56446 2.88099 4.56446C3.48894 4.56446 3.98178 4.07162 3.98178 3.46367C3.98178 2.85572 3.48894 2.36288 2.88099 2.36288Z",
    fill: "#4F55A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0102451 3.07648C0.130258 1.62052 1.34694 0.5 2.80784 0.5H2.95414C4.41504 0.5 5.63172 1.62052 5.75173 3.07648C5.8162 3.8586 5.57461 4.63521 5.07784 5.24274L3.45441 7.22816C3.15804 7.59061 2.60394 7.59061 2.30757 7.22816L0.684133 5.24275C0.187368 4.63522 -0.0542238 3.8586 0.0102451 3.07648ZM2.80784 1.00806C1.61135 1.00806 0.614877 1.92577 0.516586 3.11822C0.46293 3.76916 0.664001 4.41551 1.07744 4.92114L2.70088 6.90656C2.79397 7.0204 2.96801 7.0204 3.0611 6.90656L4.68453 4.92114C5.09798 4.41551 5.29905 3.76916 5.24539 3.11822C5.1471 1.92577 4.15063 1.00806 2.95414 1.00806H2.80784Z",
    fill: "#4F55A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.834b8ecfc0d38ef5adaaf497f434bcd7.svg";
export { ForwardRef as ReactComponent };